import React from 'react';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Parse from 'html-react-parser';

import DocumentAPI from '../../api/DocumentAPI';

import './EmailPopup.css';

class EmailViewPopup extends React.Component {

  constructor(props) {
    super(props);
    this.body = '';
    this.state = { inApiCall: false};
  }

  componentDidMount() { if(this.props.html) { this.getEmails(this.props.html); } }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.html !== this.props.html) {
      this.getEmails(props.html);
    }
  }

  getEmails = id => {
    this.setState({ inApiCall: true });
    new Promise(async resolve => {
      let res = await DocumentAPI.getPublicMediaUrl(id);
      this.body = await DocumentAPI.getText(res.url);
      resolve();
    }).then(() => this.setState({ inApiCall: false }));
  }

  render() {
    return (
      <Modal {...this.props} size="lg" aria-labelledby="contained-modal-title-vcenter"
        centered >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Email Body</Modal.Title>
        </Modal.Header>
        <Modal.Body> <Form> <div> {Parse(this.body)} </div> </Form></Modal.Body>
      </Modal>
    );
  }
}
export default EmailViewPopup;